import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import LabelledInput from 'components/LabelledInput';
import { sectionList, getActivationCode } from 'libs/subscriptionActivate';
import { changeSubscriptionActivateFields } from 'libs/cleverTap';
import {
  ACTIVATION_CODE_INFO_KEYS, ERROR_INFO_KEYS,
  ACTIVATION_CODE_FORM_ERROR_CONFIG, checkErrors
} from './config';
import SectionHeader from '../SectionHeader';
import './ActivationCodeDetails.scss';

class ActivationCodeDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activationCodeInfo: {
        [ACTIVATION_CODE_INFO_KEYS.ACTIVATION_CODE]: getActivationCode()
      },
      errorInfo: {
        [ERROR_INFO_KEYS.ACTIVATION_CODE_FORM]: {},
        errorConfigActivationCode: ACTIVATION_CODE_FORM_ERROR_CONFIG,
      },
      selectors: {
        activationCodeFieldId: 'activation-code'
      },
      currency: 'USD',
      activationCode: ''
    };
  }

  componentDidMount() {
    const activationCodeField = document.getElementById(this.state.selectors.activationCodeFieldId);

    activationCodeField.addEventListener("blur", this.handleBlur);
  }

  componentWillMount() {
    const { activationCodeInfo, errorInfo: { errorConfigActivationCode } } = this.state;
    const activationCode = activationCodeInfo[ACTIVATION_CODE_INFO_KEYS.ACTIVATION_CODE];

    this.validateFields(errorConfigActivationCode);

    if (activationCode) {
      this.props.setActivationCode(activationCode);
      this.props.setCurrentSection(sectionList.accountDetails);
    } else if (this.props.activationCode) {
      this.setState({
        activationCodeInfo: {
          ...this.state.activationCodeInfo,
          [ACTIVATION_CODE_INFO_KEYS.ACTIVATION_CODE]: this.props.activationCode,
        },
      }, () => {
        this.validateFields(errorConfigActivationCode);
        this.props.setCurrentSection(sectionList.accountDetails);
      });
    }
  }

  handleBlur = () => {
    const {
      auth: { info: userInfo },
      activationCode
    } = this.props;

    if ((activationCode && activationCode !== this.state.activationCode) && userInfo) {
      this.handleGetActivationCodeCurrency();

      this.setState({ activationCode: activationCode });
    }
  }

  handleGetActivationCodeCurrencyCallback = ({
    message, isSuccess
  }) => {
    if (message) {
      this.props.showErrorBar({ message });
    }

    if (isSuccess) {
      this.props.closeErrorBar();
    }
  }

  handleGetActivationCodeCurrency = () => {
    const { subscriptionActivate: { activationCode } } = this.props;

    this.props.getActivationCodeCurrency(
      activationCode,
      this.handleGetActivationCodeCurrencyCallback
    );
  }

  handleChange = (e) => {
    const activationCodeInfo = { ...this.state.activationCodeInfo };
    activationCodeInfo[e.target.name] = e.target.value;
    this.setState({ activationCodeInfo }, this.handleSaveActivationCode);
    changeSubscriptionActivateFields(ACTIVATION_CODE_INFO_KEYS.ACTIVATION_CODE); // track event
  }

  validateFields = (config = {}) => {
    const activationCodeInfo = { ...this.state.activationCodeInfo };
    const errorInfo = { ...this.state.errorInfo };
    const { errorFields } = config;

    const errors = checkErrors(errorFields, activationCodeInfo);
    errorInfo[config.errorKey] = errors;
    this.setState({ errorInfo });
    return errorInfo;
  }

  handleSaveActivationCode = () => {
    const { errorInfo: { errorConfigActivationCode }, activationCodeInfo } = this.state;
    this.validateFields(errorConfigActivationCode);
    const activationCode = activationCodeInfo[ACTIVATION_CODE_INFO_KEYS.ACTIVATION_CODE];

    this.props.setActivationCode(activationCode);
    this.props.checkoutActivationCode(activationCode);
  }

  render() {
    const {
      errorInfo, activationCodeInfo
    } = this.state;
    const {
      currentSection,
      sectionHeader: { label },
      windowDimension, intl
    } = this.props;
    const errorInfoActivationCodeForm = errorInfo[ERROR_INFO_KEYS.ACTIVATION_CODE_FORM] || {};

    return (
      <div className="ActivationCodeDetails">
        <SectionHeader
          label={label}
          activeSection={currentSection}
          windowDimension={windowDimension}
        />
        <div className="ActivationCodeDetails__FormCard">
          <div className="ActivationCodeDetails__FormCard__InputWrap">
            <LabelledInput
              id={"activation-code"}
              name={ACTIVATION_CODE_INFO_KEYS.ACTIVATION_CODE}
              onChange={this.handleChange}
              value={activationCodeInfo[ACTIVATION_CODE_INFO_KEYS.ACTIVATION_CODE]}
              onEnter={this.handleSaveActivationCode}
              errorText={errorInfoActivationCodeForm[ACTIVATION_CODE_INFO_KEYS.ACTIVATION_CODE] &&
                intl.formatMessage(
                  { id: errorInfoActivationCodeForm[ACTIVATION_CODE_INFO_KEYS.ACTIVATION_CODE] }
                )}
              placeholder={intl.formatMessage({ id: 'views.subscriptionActivate.activationCodeDetails.formCard.inputWrap.activationCode.placeholder' })}
            />
          </div>
        </div>
      </div>
    );
  }
}

ActivationCodeDetails.propTypes = {
  sectionHeader: PropTypes.object.isRequired,
  currentSection: PropTypes.string.isRequired,
  windowDimension: PropTypes.object.isRequired,
  setCurrentSection: PropTypes.func.isRequired,
  setActivationCode: PropTypes.func.isRequired,
  activationCode: PropTypes.string.isRequired,
  checkoutActivationCode: PropTypes.func.isRequired,
  auth: PropTypes.object,
  intl: PropTypes.object.isRequired
};

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(injectIntl(ActivationCodeDetails));



// WEBPACK FOOTER //
// ./src/views/SubscriptionActivate/ActivationCodeDetails/ActivationCodeDetails.jsx